<template>
    <tr>
        <td>
            <a class="action detail-link" v-on:click="showDetail">{{title}}</a>
        </td>
        <td>
            {{createdDate}}
        </td>
        <td>
            {{state}}
        </td>
        <td>
            {{areaName}}
        </td>
    </tr>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SupportTicketItem',

  mixins: [mixins],

  props: [
    'id',
    'title',
    'tag_id',
    'state',
    'type',
    'created',
    'createdBy'
  ],

  computed: {
    ...mapState('user', [
      'userTimezone'
    ]),

    ...mapState('support', [
      'tickets',
      'tags',
      'supportTicketDetailId',
      'showDetailPage'
    ]),

    createdDate () {
      return this.transformTime(this.created, this.userTimezone)
    },

    areaName () {
      const tag = this.tags.filter((element) => {
        return element.id === this.tag_id
      })

      return tag.length > 0 ? tag[0].name : ''
    }

  },

  data () {
    return {
    }
  },

  methods: {
    ...mapMutations('support', [
      'closeSupportDetailPage',
      'showSupportDetailPage',
      'setSupportTicketDetail'
    ]),

    showDetail () {
      if (this.id === this.supportTicketDetailId && this.showDetailPage) {
        this.closeSupportDetailPage()
      } else {
        this.setSupportTicketDetail(this.id)

        if (!this.showDetailPage) {
          this.showSupportDetailPage()
        }
      }
    }
  }
}
</script>
